import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import * as dateutil from "@appbase/util/date-helper";

import AttendanceManageModal from './AttendanceManageModal.vue';

@Component({
    components: {
        AttendanceManageModal
    }
})
export default class AttendanceManage extends Vue {
    @Prop({ type: Array }) weekList!: Date[];
    @Prop({ type: Array }) attendanceDataList!: any[];
    @Prop({ type: Number }) storeType!: number;

    weekLabel = [
        { key: 0, text: this.$t('월').toString() },
        { key: 1, text: this.$t('화').toString() },
        { key: 2, text: this.$t('수').toString() },
        { key: 3, text: this.$t('목').toString() },
        { key: 4, text: this.$t('금').toString() },
        { key: 5, text: this.$t('토').toString() },
        { key: 6, text: this.$t('일').toString() }
    ]

    convertDate(date: Date) {
        return dateutil.uGetDateFormat('MM/DD', date);
    }

    openModal() {
        const modal: appbase.IModalOpenable = this.$refs['modal'] as any
        const options: appbase.TModalInfo<any> = {
          component: AttendanceManageModal,
          props: { },
          events: {
            cancel: () => {
              modal.closeModal()
            },
          },
        }
        modal.openModal(options)
    }
}